module.exports = __webpack_public_path__ + "static/img/khk002b-2.78e996f5.png";